import * as React from 'react';
import {FirstScreen} from './screens/FirstScreen';
import {SecondScreen} from './screens/SecondScreen';
import {FourthScreen} from './screens/FourthScreen';
import {FifthScreen} from './screens/FifthScreen';
import {analyticsEvent} from '../utils/analytics';
import {WP_CONTENT_PREFIX} from "../constants";

export class OnboardingStart extends React.Component {

    constructor() {
        super();
        this.state = {
            finishedThirdScreen: false,
            finishedDownloading: false,
            musicPlaying: false,
            audioElement: null
        };

        this.preventDefault = this.preventDefault.bind(this);
        this.keydown = this.keydown.bind(this);
        this.removeScrolling = this.removeScrolling.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.toggleMusicPlaying = this.toggleMusicPlaying.bind(this);
    }

    preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault)
            e.preventDefault();
        e.returnValue = false;
    }

    keydown(e) {
        const keys = [32,33,34,35,36,37,38,39,40];
        for (let i = keys.length; i--;) {
            if (e.keyCode === keys[i]) {
                this.preventDefault(e);
                return;
            }
        }
    }

    removeScrolling() {
        if (document.addEventListener) {
            document.addEventListener('DOMMouseScroll', this.preventDefault, false);
        }
        window.onmousewheel = document.onmousewheel = this.preventDefault;
        document.onkeydown = this.keydown;
    }

    scrollToBottom() {
        const {fourthScreen} = this.refs;
        fourthScreen.scrollTop = fourthScreen.scrollHeight;
    }

    toggleMusicPlaying() {
        const {audioElement, musicPlaying} = this.state;
        if (audioElement === null && !musicPlaying) {
            let newAudioElement = new Audio(`${WP_CONTENT_PREFIX}/audio/retroMusic.mp3`);
            newAudioElement.loop = true;
            newAudioElement.play();
            this.setState({
                musicPlaying: true,
                audioElement: newAudioElement
            });
        } else {
            audioElement.pause();
            this.setState({
                musicPlaying: false,
                audioElement: null
            });
        }
    }

    componentDidUpdate (prevState) {
        const {finishedThirdScreen, finishedDownloading} = this.state;
        if(!prevState.finishedThirdScreen && finishedThirdScreen) {
            this.scrollToBottom()
        }
        if(!prevState.finishedDownloading && finishedDownloading)  {
            analyticsEvent('Onboarding',
                'Screen 5',
                'Image downloaded'
            );
        }
    }

    componentDidMount() {
        document.title = 'The Mouse Chase - Introducing CrxMouse - Start game';
        document.addEventListener('finishedThirdScreen', () => {
            this.setState({
                finishedThirdScreen: true
            });
            document.title = 'The Mouse Chase - Introducing CrxMouse - Save Princess';
        });
        document.addEventListener('finishedDownloading', () => {
            this.setState({
                finishedDownloading: true
            });
        });
        this.removeScrolling();
    }


    render() {
        const {finishedThirdScreen, finishedDownloading, musicPlaying} = this.state;
        const {extensionInstalled} = this.props;
        return finishedThirdScreen ?
            <React.Fragment>
                <FifthScreen finishedDownloading={finishedDownloading} toggleMusicPlaying={this.toggleMusicPlaying} musicPlaying={musicPlaying}/>
                <FourthScreen ref='fourthScreen' toggleMusicPlaying={this.toggleMusicPlaying} musicPlaying={musicPlaying} />
            </React.Fragment> :
            <React.Fragment>
                <FirstScreen extensionInstalled={extensionInstalled} toggleMusicPlaying={this.toggleMusicPlaying} musicPlaying={musicPlaying}/>
                <SecondScreen extensionInstalled={extensionInstalled} toggleMusicPlaying={this.toggleMusicPlaying} musicPlaying={musicPlaying}/>
            </React.Fragment>;
    }
}
